import React, {useMemo} from 'react';

const colors = ['#69D994', '#9DDEAD', '#B3E5C2', '#E5F6EB'];
const ballCount = 10;
const ringCount = 20;

const randRange = (min: number, max: number) => (
	Math.random() * (max - min) + min
);

const useRicochetsAndRings = () => (
	useMemo(() => {
		const generated: JSX.Element[] = [];

		// Bouncing balls
		for (let i = 0; i < ballCount; i++) {
			const size = randRange(2, 5);
			const colorIndex = i % 4;
			const speedX = randRange(20, 25);
			const speedY = randRange(20, 25);
			const delay = randRange(0, 2);

			// Randomize starting position and direction
			const startX = randRange(25, 75);
			const startY = randRange(0, 100);
			const endX = randRange(0, 100);
			const endY = randRange(0, 100);

			// Create bouncing animation
			generated.push(
				<circle
					key={`ball-${i}`}
					cx={startX}
					cy={startY}
					r={size}
					fill={colors[colorIndex]}
					opacity='0.8'
				>
					<animate
						attributeName='cx'
						values={`${startX};${endX};${startX}`}
						dur={`${speedX}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
						calcMode='linear'
					/>
					<animate
						attributeName='cy'
						values={`${startY};${endY};${startY}`}
						dur={`${speedY}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
						calcMode='linear'
					/>
				</circle>
			);
		}

		// Expanding rings
		for (let i = 0; i < ringCount; i++) {
			const x = randRange(25, 75);
			const y = randRange(0, 100);
			const maxRadius = randRange(5, 20);
			const colorIndex = i % 4;
			const duration = randRange(5, 7);
			const delay = randRange(0, 5);

			generated.push(
				<circle
					key={`ring-${i}`}
					cx={x}
					cy={y}
					r='0'
					fill='none'
					stroke={colors[colorIndex]}
					strokeWidth='1'
					opacity='0.6'
				>
					<animate
						attributeName='r'
						values={`0;${maxRadius}`}
						dur={`${duration}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
					/>
					<animate
						attributeName='opacity'
						values='0.6;0'
						dur={`${duration}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
					/>
					{/* <animate
						attributeName='stroke-width'
						values='1;0.2'
						dur={`${duration}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
					/> */}
				</circle>
			);
		}
		return generated;
	}, [])
);

export const RicochetsAndRings: React.FC = () => {
	const elements = useRicochetsAndRings();
	return (
		<div>
			<svg
				width='100%'
				height='100%'
				viewBox='0 0 100 100'
				preserveAspectRatio='none'
			>
				{elements}
			</svg>
		</div>
	);
};
